@import '../../../globals/main.scss';
@import './pn-site-selector-common.scss';

pn-site-selector-item {
  display: block;
  > div,
  > a {
    padding: 0.8rem 0;
    display: flex;
    flex-flow: column;
    position: relative;
  }
}

.siteselector-item-link {
  border-radius: 0;
  text-decoration: none;
  color: $blue700;
  flex-direction: row;

  &:hover,
  &:focus {
    background-color: $gray50;
    color: $blue700;
    text-decoration: underline;
    outline: none;
    box-shadow: none;
  }

  &:active {
    background-color: $gray50;
    color: $blue400;
    outline: none;
  }
  > span {
    flex-grow: 1;
  }
  pn-icon {
    right: 3.2rem;
    height: 1.9rem;
    width: 1.9rem;
    align-self: center;

    svg {
      width: 100%;
      height: auto;
    }
  }
}
.siteselector-item-title {
  display: block;
}

.siteselector-item-description {
  color: $gray900;
  font-size: 1.28rem;

  a:hover > &,
  a:focus > & {
    background-color: $gray50;
    color: $blue700;
    text-decoration: underline;
    outline: none;
  }

  a:active > & {
    background-color: $gray50;
    color: $blue400;
    outline: none;
  }
}
